export default {
  data() {
    return {
      iconCode: {
        actions: 'fa-light fa-screwdriver-wrench',
        add: 'fa-light fa-plus',
        beneficiaries: 'fa-light fa-family',
        brand: 'fa-duotone fa-store',
        clear: 'fa-light fa-eraser',
        close: 'fa-light fa-xmark-large',
        filter: 'fa-light fa-filter',
        help: 'fa-light fa-circle-question',
        home: 'fa-light fa-house',
        menu: 'fa-light fa-bars',
        scan: 'fa-light fa-barcode',
        showDetails: 'fa-light fa-memo-circle-info',
        user: 'fa-light fa-user',
        expandableSection: {
          collapse: 'fa-light fa-angle-up',
          enterFullscreen: 'fa-light fa-maximize',
          exitFullscreen: 'fa-light fa-minimize',
          expand: 'fa-light fa-angle-down',
        },
        message: {
          success: 'fa-light fa-check',
          info: 'fa-light fa-info',
          warning: 'fa-light fa-exclamation-triangle',
          danger: 'fa-light fa-exclamation-circle',
        },
        sidenav: {
          menu: 'fa-light fa-folder',
          link: 'fa-light fa-page',
        },
      },
      iconPositionClass: {
        beforeText: 'mr-2',
        afterText: 'ml-2',
      },
      iconFlipClass: {
        horizontal: 'fa-flip-horizontal',
        vertical: 'fa-flip-vertical',
      },
    };
  },
};
